import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const cardiacFeatures = [
  "Critical medication management",
  "Vital signs monitoring",
  "Cognitive function tracking",
  "Early warning detection"
];

const orthopedicFeatures = [
  "Physical therapy adherence",
  "Recovery milestone tracking",
  "Activity level monitoring",
  "Pain management support"
];

export const WhySpecialtiesSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-8">Why Cardiac and Orthopedic Care?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Research shows up to 30% of cardiac surgery patients and 15-20% of orthopedic patients experience cognitive changes during recovery. Our platform uniquely addresses both physical and cognitive aspects of healing.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="bg-white p-8 rounded-2xl shadow-lg"
          >
            <h3 className="text-2xl font-bold mb-4">Cardiac Surgery Focus</h3>
            <ul className="space-y-3">
              {cardiacFeatures.map((feature, index) => (
                <li key={index} className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="bg-white p-8 rounded-2xl shadow-lg"
          >
            <h3 className="text-2xl font-bold mb-4">Orthopedic Recovery Focus</h3>
            <ul className="space-y-3">
              {orthopedicFeatures.map((feature, index) => (
                <li key={index} className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};